import { MoveTicketHeader } from '../components/MoveTicketHeader';
import { jsx as _jsx } from "react/jsx-runtime";
export function MoveTicketToSupportCardHeader() {
  return /*#__PURE__*/_jsx(MoveTicketHeader, {});
}